export default __webpack_public_path__ + "static/media/Men_Sizing_Chart.c15e46ce.png";